import { BellRing } from 'lucide-react';
import { formatDate } from '@/lib/dateFormat';

const YEAR_MS = 365.25 * 24 * 60 * 60 * 1000;

/**
 * Warranty expiry display: the date, plus a bold "Expired Ny" label when the
 * date is in the past, and an alarm-bell icon once it's expired by more than
 * three years. Renders an em-dash when there's no date.
 */
export function WarrantyExpiry({ value }: { value: string | null | undefined }) {
  if (!value) return <span className="text-darkGrey/50">—</span>;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return <span className="text-darkGrey/80">{formatDate(value)}</span>;

  const elapsedYears = (Date.now() - d.getTime()) / YEAR_MS;
  const expired = elapsedYears > 0;
  const wholeYears = Math.floor(elapsedYears);

  return (
    <span className="inline-flex items-center gap-1.5">
      <span className="text-darkGrey/80">{formatDate(value)}</span>
      {expired && (
        <span className="font-bold text-red">
          Expired{wholeYears >= 1 ? ` ${wholeYears}y` : ''}
        </span>
      )}
      {elapsedYears > 3 && (
        <BellRing className="h-4 w-4 text-red" aria-label={`Warranty expired ${wholeYears} years ago`} />
      )}
    </span>
  );
}
